/*
    BEEP BOP BOOP - I AM AN AUTO GENERATED FILE - DO NOT EDIT ME MANUALLY
*/


// Name: Security JSON Schemas 

const _IP_ADDRESS_JSON_SCHEMA = {
    "$ref": "#/definitions/IPAddressSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "IPAddressSchema": {
            "additionalProperties": false,
            "properties": {
                "city": {
                    "title": "City",
                    "type": "string"
                },
                "country": {
                    "title": "Country",
                    "type": "string"
                },
                "first_seen_timestamp": {
                    "format": "date-time",
                    "title": "First Seen Timestamp",
                    "type": "string"
                },
                "flagged_for_review": {
                    "title": "Flagged For Review",
                    "type": "boolean"
                },
                "ip_address": {
                    "title": "Ip Address",
                    "type": "string"
                },
                "ip_hash": {
                    "title": "Ip Hash",
                    "type": "string"
                },
                "ip_uid": {
                    "reference_type": "uuid",
                    "title": "Ip Uid",
                    "type": "string",
                    "uid_resource_type": "ip_address"
                },
                "last_lookup_timestamp": {
                    "format": "date-time",
                    "title": "Last Lookup Timestamp",
                    "type": "string"
                },
                "last_seen_timestamp": {
                    "format": "date-time",
                    "title": "Last Seen Timestamp",
                    "type": "string"
                },
                "lookup_complete": {
                    "title": "Lookup Complete",
                    "type": "boolean"
                },
                "raw_ip_lookup_data": {
                    "title": "Raw Ip Lookup Data",
                    "type": "string"
                },
                "region": {
                    "title": "Region",
                    "type": "string"
                }
            },
            "required": [
                "city",
                "country",
                "first_seen_timestamp",
                "flagged_for_review",
                "ip_address",
                "ip_hash",
                "ip_uid",
                "last_lookup_timestamp",
                "last_seen_timestamp",
                "lookup_complete",
                "raw_ip_lookup_data",
                "region"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _KNOWN_IP_ADDRESS_JSON_SCHEMA = {
    "$ref": "#/definitions/KnownIPAddressSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "KnownIPAddressSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "first_use_timestamp": {
                    "format": "date-time",
                    "title": "First Use Timestamp",
                    "type": "string"
                },
                "ip_address_uid": {
                    "reference_type": "uuid",
                    "title": "Ip Address Uid",
                    "type": "string",
                    "uid_resource_type": "ip_address"
                },
                "known_ip_uid": {
                    "reference_type": "uuid",
                    "title": "Known Ip Uid",
                    "type": "string",
                    "uid_resource_type": "known_ip_address"
                },
                "last_use_timestamp": {
                    "format": "date-time",
                    "title": "Last Use Timestamp",
                    "type": "string"
                }
            },
            "required": [
                "account_uid",
                "first_use_timestamp",
                "ip_address_uid",
                "known_ip_uid",
                "last_use_timestamp"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _KNOWN_USER_AGENT_JSON_SCHEMA = {
    "$ref": "#/definitions/KnownUserAgentSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "KnownUserAgentSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "first_use_timestamp": {
                    "format": "date-time",
                    "title": "First Use Timestamp",
                    "type": "string"
                },
                "known_user_agent_uid": {
                    "reference_type": "uuid",
                    "title": "Known User Agent Uid",
                    "type": "string",
                    "uid_resource_type": "known_user_agent"
                },
                "last_use_timestamp": {
                    "format": "date-time",
                    "title": "Last Use Timestamp",
                    "type": "string"
                },
                "user_agent_uid": {
                    "reference_type": "uuid",
                    "title": "User Agent Uid",
                    "type": "string",
                    "uid_resource_type": "user_agent"
                }
            },
            "required": [
                "account_uid",
                "first_use_timestamp",
                "known_user_agent_uid",
                "last_use_timestamp",
                "user_agent_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _USER_AGENT_JSON_SCHEMA = {
    "$ref": "#/definitions/UserAgentSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "UserAgentSchema": {
            "additionalProperties": false,
            "properties": {
                "browser_family": {
                    "title": "Browser Family",
                    "type": "string"
                },
                "browser_version": {
                    "title": "Browser Version",
                    "type": "string"
                },
                "device_brand": {
                    "title": "Device Brand",
                    "type": "string"
                },
                "device_family": {
                    "title": "Device Family",
                    "type": "string"
                },
                "device_model": {
                    "title": "Device Model",
                    "type": "string"
                },
                "first_seen_timestamp": {
                    "format": "date-time",
                    "title": "First Seen Timestamp",
                    "type": "string"
                },
                "last_lookup_timestamp": {
                    "format": "date-time",
                    "title": "Last Lookup Timestamp",
                    "type": "string"
                },
                "last_seen_timestamp": {
                    "format": "date-time",
                    "title": "Last Seen Timestamp",
                    "type": "string"
                },
                "os_family": {
                    "title": "Os Family",
                    "type": "string"
                },
                "os_version": {
                    "title": "Os Version",
                    "type": "string"
                },
                "raw_user_agent_string": {
                    "title": "Raw User Agent String",
                    "type": "string"
                },
                "user_agent_hash": {
                    "title": "User Agent Hash",
                    "type": "string"
                },
                "user_agent_uid": {
                    "reference_type": "uuid",
                    "title": "User Agent Uid",
                    "type": "string",
                    "uid_resource_type": "user_agent"
                }
            },
            "required": [
                "browser_family",
                "browser_version",
                "device_brand",
                "device_family",
                "device_model",
                "first_seen_timestamp",
                "last_lookup_timestamp",
                "last_seen_timestamp",
                "os_family",
                "os_version",
                "raw_user_agent_string",
                "user_agent_hash",
                "user_agent_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};


export const IP_ADDRESS_JSON_SCHEMA = _IP_ADDRESS_JSON_SCHEMA.definitions.IPAddressSchema;
export const KNOWN_IP_ADDRESS_JSON_SCHEMA = _KNOWN_IP_ADDRESS_JSON_SCHEMA.definitions.KnownIPAddressSchema;
export const KNOWN_USER_AGENT_JSON_SCHEMA = _KNOWN_USER_AGENT_JSON_SCHEMA.definitions.KnownUserAgentSchema;
export const USER_AGENT_JSON_SCHEMA = _USER_AGENT_JSON_SCHEMA.definitions.UserAgentSchema;
